import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  profile,
  alert,
  float,
  toFixed,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  required,
  Select,
  Pagination,
  Switch,
  Navbar,
  Modal,
  CopyCell,
  copyText,
  maskAccount,
} from "../../components/CustomComponent.js";

// PayoutID = contact id ฝั่ง reservepay ที่เก็บไว้ตอนสร้างลูกค้า ไม่ใช่ gateway ตัวแรกที่เจอ
const payoutId = (item) =>
  item?.gateway_register?.find((e) => e.gateway_name === "reservepay")?.uid || "";

// Gold-accented toggle to match the premium theme (same as the Users page).
const SWITCH_PROPS = {
  onColor: "#c9a23a",
  offColor: "#cbd5e1",
  onHandleColor: "#ffffff",
  checkedIcon: false,
  uncheckedIcon: false,
  height: 22,
  width: 42,
  handleDiameter: 16,
  activeBoxShadow: "0 0 0 3px rgba(212, 175, 55, 0.3)",
};

// ---------------------------------------------------------------------------
// Layout shares the premium look of /su/users and /su/agents; the business
// logic (Get / GetBank / CreateUpdate / Delete / CheckAccount), state field
// names and API payloads are unchanged from the previous version of this page.
// ---------------------------------------------------------------------------

// สีของสถานะ KYC ตามค่าที่ Primerlo คืน (GET /v1/partner/users)
const KYC_COLORS = {
  approved: "success",
  pending: "warning",
  review: "warning",
  rejected: "danger",
  expired: "danger",
  bank_required: "warning",
  none: "secondary",
};

// ตัวกรอง KYC (Backend รับ kyc_status ตามค่าเดียวกับ KYC_COLORS · none = ยังไม่เคยเข้า Primerlo)
const KYC_FILTER_OPTIONS = [
  { value: "", label: "All (KYC)" },
  { value: "approved", label: "Approved" },
  { value: "pending", label: "Pending" },
  { value: "review", label: "Review" },
  { value: "bank_required", label: "Bank required" },
  { value: "rejected", label: "Rejected" },
  { value: "expired", label: "Expired" },
  { value: "none", label: "No KYC" },
];

export default class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_currency: "THB",
      filter_broker_id: "",
      filter_is_blacklist: "",
      filter_kyc_status: "",

      hover_index: -1,

      loaded: false,
      data: [],
      count: 0,
      page: 1,
      page_size: 10,
      data_broker: [],
      data_bank: [],
      data_gateway: [],

      id: "",
      uid: "",
      broker_id: "",
      currency: "",
      customer_ref: "",
      name_th: "",
      name_en: "",
      email: "",
      deposit_fee_type: "",
      deposit_fee_value: 0,
      withdrawal_fee_type: "",
      withdrawal_fee_value: 0,
      is_vat: false,
      bank_code: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      bank_account_number: "",
      company_name: "",
      company_address: "",
      company_website: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      remark: "",
      callback_url: "",
      is_active: true,
      gateway_register: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.Get(1), this.GetBroker()]);
  }
  GetBroker = async () => {
    const result_broker = await GET("v1/admin/brokers/options", {
      page_size: 100000,
      page: 0,
      data_search: "",
    });
    if (result_broker?.status) {
      this.setState({
        data_broker: result_broker.data.map((e) => ({
          value: e.uid,
          label: e.name_en,
          gateway: e.gateway_deposits,
          gateway_active: e.gateway_active || [],
        })),
      });
    }
  };
  Get = async (page) => {
    const {
      filter_search,
      filter_currency,
      filter_broker_id,
      filter_is_blacklist,
      filter_kyc_status,
      page_size,
    } = this.state;
    loading(true);
    const result = await GET("v1/admin/customers", {
      page_size: page_size,
      page: page,
      data_search: filter_search,
      currency: filter_currency,
      broker_id: filter_broker_id,
      is_blacklist: filter_is_blacklist,
      kyc_status: filter_kyc_status,
    });
    loading(false);

    // ยิงไม่ผ่านต้องคงข้อมูลเดิมไว้ ไม่ใช่ล้างตารางเป็น No data โดยไม่บอกสาเหตุ
    if (result?.status !== true) {
      this.setState({ loaded: true });
      return;
    }

    this.setState({
      loaded: true,
      page: page,
      data: result.data || [],
      count: result.pagination?.count || 0,
    });
  };
  GetBank = async (gateway) => {
    const fetchBanks = (gw) =>
      GET("v1/admin/banks", {
        page_size: 100000,
        page: 0,
        data_search: "",
        gateway: gw,
      });
    let result = await fetchBanks(gateway);
    let rows = result?.status === true ? result.data.filter((e) => e.bank_gateway_mappings) : [];
    // backend กรองด้วย inner join กับ bank_gateway_mappings ของ gateway นั้น
    // gateway ที่ยังไม่มี mapping (เช่น primerlo หรือ THB หลังเลิกใช้ reservepay)
    // จึงได้ลิสต์ว่างและช่อง Bank Name ว่างทั้ง create/update ถอยไปใช้ธนาคารทั้งหมดแทน
    if (!rows.length && gateway) {
      result = await fetchBanks("");
      rows = result?.status === true ? result.data : [];
    }
    if (result?.status === true) {
      const popularBankCodes = [
        "SCB",
        "KBANK",
        "KTB",
        "BBL",
        "BAY",
        "TTB",
        "CIMB",
      ];
      this.setState({
        data_bank: rows
          .sort((a, b) => {
            const indexA = popularBankCodes.indexOf(a.code);
            const indexB = popularBankCodes.indexOf(b.code);

            if (indexA !== -1 && indexB !== -1) {
              return indexA - indexB; // ถ้าอยู่ทั้งคู่ใน popular → เรียงตามลำดับ
            } else if (indexA !== -1) {
              return -1; // a อยู่ใน popular → ให้มาก่อน
            } else if (indexB !== -1) {
              return 1; // b อยู่ใน popular → ให้มาก่อน
            } else {
              return a.name_en.localeCompare(b.name_en); // ไม่อยู่ใน popular → เรียงตามชื่อ
            }
          })
          .map((e) => ({
            value: e.code,
            label: e.name_en,
            country: e.country,
            front: (
              <img
                alt="bank"
                src={require(`../../assets/images/bank/${
                  global.bank.find((b) => b.value === e.code)?.icon ||
                  "bank.png"
                }`)}
                width={18}
                height={18}
                style={{ marginRight: 6 }}
              />
            ),
          })),
      });
    } else {
      loading(false);
    }
  };
  CreateUpdate = async () => {
    const {
      uid,
      broker_id,
      name_th,
      currency,
      customer_ref,
      name_en,
      email,
      deposit_fee_type,
      deposit_fee_value,
      withdrawal_fee_type,
      withdrawal_fee_value,
      is_vat,
      bank_code,
      bank_account_name_th,
      bank_account_name_en,
      bank_account_number,
      company_name,
      company_address,
      company_website,
      contact_name,
      contact_email,
      contact_phone,
      remark,
      callback_url,
      is_active,
      is_blacklist
    } = this.state;
    if (!broker_id.trim()) {
      alert("", "warning", "Warning", "Please input Broker");
      return;
    } else if (!name_th.trim()) {
      alert("", "warning", "Warning", "Please input Name TH");
      return;
    } else if (!name_en.trim()) {
      alert("", "warning", "Warning", "Please input Name EN");
      return;
    } else if (!currency.trim()) {
      alert("", "warning", "Warning", "Please select Currency");
      return;
    } else if (!bank_code.trim()) {
      alert("", "warning", "Warning", "Please select Bank Name");
      return;
    } else if (!bank_account_number.trim()) {
      alert("", "warning", "Warning", "Please input Account Number");
      return;
    } else if (!bank_account_name_th.trim()) {
      alert("", "warning", "Warning", "Please input Account NameTH");
      return;
    } else if (!bank_account_name_en.trim()) {
      alert("", "warning", "Warning", "Please input Account Name EN");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      const { destination_address } = this.state;
      if (destination_address && !/^0x[0-9a-fA-F]{40}$/.test(destination_address.trim())) {
        alert("", "warning", "Warning", "Destination Address must be a BSC address: 0x followed by 40 hex characters");
        return;
      }
      loading(true);
      let body = {
        broker_id,
        currency,
        customer_ref,
        destination_address: (destination_address || "").trim(),
        name_th,
        name_en,
        email,
        deposit_fee_type,
        deposit_fee_value: Number(deposit_fee_value),
        withdrawal_fee_type,
        withdrawal_fee_value: Number(withdrawal_fee_value),
        is_vat,
        bank_code,
        bank_account_name_th,
        bank_account_name_en,
        bank_account_number,
        company_name,
        company_address,
        company_website,
        contact_name,
        contact_email,
        contact_phone,
        remark,
        callback_url,
        is_active,
        is_blacklist
      };

      let result = !uid
        ? await POST("v1/admin/customers", body)
        : await PUT("v1/admin/customers/" + uid, body);
      if (result?.status === true) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "Delete Item",
        "Do you really want to delete this item?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      await DELETE("v1/admin/customers/" + id, null);
      alert("#", "success");
      loading(false);
    }
  };
  CheckAccount = async () => {
    const { bank_code, bank_account_number } = this.state;
    loading(true);
    let result = await POST("v1/admin/customers/verify-bank-account", {
      bank_code,
      bank_account_number,
    });
    if (result?.data) {
      alert(
        "",
        "success",
        "Bank Account Validated",
        "Your bank account details have been verified and are correct."
      );
    } else {
      alert(
        "",
        "warning",
        "Bank Account Verification Failed",
        "Your bank account couldn’t be verified. Please make sure the information is correct."
      );
    }
    loading(false);
  };
  // -------------------------------------------------------------------------
  // Render helpers (presentation only)
  // -------------------------------------------------------------------------
  openCreate = () => {
    this.setState({
      id: "",
      uid: "",
      broker_id: profile?.user_type === "broker" ? profile?.broker?.uid : "",
      name_th: "",
      currency: "THB",
      customer_ref: "",
      name_en: "",
      email: "",
      deposit_fee_type: "",
      deposit_fee_value: "",
      withdrawal_fee_type: "",
      withdrawal_fee_value: "",
      is_vat: false,
      bank_code: "",
      bank_account_name_th: "",
      bank_account_name_en: "",
      bank_account_number: "",
      company_name: "",
      company_address: "",
      company_website: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
      remark: "",
      callback_url: "",
      destination_address: "",
      kyc_status: "",
      data_bank: [],
      is_active: true,
      is_blacklist: false,
      modal_create: true,
    });
    if (profile?.user_type === "broker") {
      this.GetBank(profile?.broker?.gateway_deposits || "");
    }
  };
  openUpdate = (item) => {
    // gateway ถูกตั้งแยกตาม currency ต้อง resolve แบบเดียวกับ
    // ตอนเลือก Broker/Currency ไม่งั้น broker ที่ตั้ง gateway
    // ไว้เฉพาะราย currency จะได้ Bank Name ว่าง
    const cur = item.currency || "THB";
    const brk = this.state.data_broker?.find((b) => b.value === item.broker?.uid);
    const gw =
      brk?.gateway_active?.find((g) => g.currency === cur)?.gateway_deposits ||
      brk?.gateway ||
      item.broker?.gateway_deposits;

    // address USDT (BSC) และสถานะ KYC ของ primerlo อยู่ในแถว gateway_register ไม่ใช่ field ตรงของลูกค้า
    const primerloRow = item.gateway_register?.find((g) => g.gateway_name === "primerlo");

    this.setState({
      ...item,
      broker_id: item.broker?.uid || "",
      destination_address: primerloRow?.destination_address || "",
      kyc_status: primerloRow?.kyc_status || "",
      data_bank: [],
      modal_update: true,
    });

    if (gw) this.GetBank(gw);
  };
  closeModal = () => {
    this.setState({ modal_create: false, modal_update: false });
  };
  renderRisk = (item, index) => {
    const { hover_index } = this.state;
    const chip =
      item.risk_level === "LOW"
        ? Status("LOW", "warning")
        : item.risk_level === "MEDIUM"
        ? Status("MEDIUM", "orange")
        : item.risk_level === "HIGH"
        ? Status("HIGH", "danger")
        : item.risk_level === "CRITICAL"
        ? Status("CRITICAL", "dark")
        : item.is_blacklist
        ? Status("BLACKLIST", "secondary")
        : <span className="pu-none">-</span>;
    return (
      <div className="d-flex align-items-center justify-content-center">
        {chip}
        {item.is_blacklist ? (
          <div
            className="pu-tip-anchor"
            onMouseEnter={() => this.setState({ hover_index: index })}
            onMouseLeave={() => this.setState({ hover_index: null })}
          >
            <span className="pu-tip-icon icon">{""}</span>
            {hover_index === index && (
              <div className="pu-tip">
                {item.risk_detail ||
                  "Your account requires additional review before proceeding."}
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  };
  // ขอลิงก์หน้า KYC ตัวกลางของเรา (/kyc?t=token อายุ 24 ชม.) ออกให้เฉพาะลูกค้าของ broker ที่ใช้ primerlo
  // copy=false เปิดแท็บใหม่ให้ลูกค้าทำ KYC ต่อ · copy=true คัดลอกลิงก์ไว้ส่งลูกค้า (GET แจ้ง error เองเมื่อไม่สำเร็จ)
  OpenKyc = async (item, copy = false) => {
    loading(true);
    const result = await GET(`v1/admin/customers/${item.uid}/kyc-link`);
    loading(false);
    if (!result?.status || !result.data?.kyc_url) return;
    if (copy) return copyText(result.data.kyc_url);
    window.open(result.data.kyc_url, "_blank", "noopener");
  };
  // สถานะ KYC กับ Primerlo (customers_gatewaies.kyc_status ของแถว gateway primerlo) ลูกค้าที่ไม่เคยเข้า Primerlo แสดง "-"
  renderKyc = (item) => {
    const row = item.gateway_register?.find((g) => g.gateway_name === "primerlo");
    const kyc = row?.kyc_status;
    if (!row || !kyc) return <span className="pu-none">-</span>;
    const color = KYC_COLORS[kyc] || "secondary";
    const title = row.kyc_updated_at ? `Primerlo KYC updated ${new Date(row.kyc_updated_at).toLocaleString("th-TH", { hour12: false })}` : "Primerlo KYC";
    const address = row.destination_address;
    return (
      <div className="d-flex flex-column align-items-center">
        <span title={title}>{Status(kyc, color)}</span>
        {address ? (
          <CopyCell value={address} label={`${address.slice(0, 6)}…${address.slice(-4)}`} className="pu-sub pu-mono mt-1" duration={2000} />
        ) : null}
      </div>
    );
  };
  renderRow = (item, index) => {
    // ธนาคารที่ไม่อยู่ใน global.bank (เช่น ธนาคารฝั่ง LAK) ยังต้องโชว์ code ไม่ใช่ "-"
    const bank = item.bank_code
      ? global.bank.find((e) => e.value === item.bank_code) || { icon: "bank.png" }
      : null;
    const name = item.name_en || item.name_th || "-";
    const mismatch = item.qty_mismatch !== 0;
    return (
      <tr key={item.uid || `array-${index}`} className={mismatch ? "pu-row-mismatch" : ""}>
        <td data-label="UID" className="text-nowrap">
          <div className="pu-uid">
            <CopyCell
              value={item.uid}
              label={item.uid ? item.uid.slice(0, 12) + "..." : "-"}
              className="pu-shq-ref"
              duration={2000}
            />
            {payoutId(item) ? (
              <CopyCell
                value={payoutId(item)}
                label={`PayoutID: ${payoutId(item)}`}
                className="pu-sub"
                duration={2000}
              />
            ) : (
              <span className="pu-sub pu-none">PayoutID: -</span>
            )}
          </div>
        </td>
        <td data-label="Customer" className="text-nowrap">
          <div className="pu-user">
            <div className="min-w-0">
              <div className="pu-name text-truncate" title={name}>
                {name}
              </div>
              <div className="pu-sub">
                <span className="icon me-1">{""}</span>
                <span className="text-truncate">
                  {item.broker?.name_en || item.broker?.name_th || "-"}
                </span>
              </div>
            </div>
          </div>
        </td>
        <td data-label="Bank" className="text-nowrap">
          {bank ? (
            <div className="pu-bank">
              <img
                alt="bank"
                src={require(`../../assets/images/bank/${bank.icon || "bank.png"}`)}
                width={28}
                height={28}
              />
              <div className="min-w-0">
                <div className="pu-bank-code">{item.bank_code}</div>
                <div className="pu-sub pu-mono">{maskAccount(item.bank_account_number) || "-"}</div>
              </div>
            </div>
          ) : (
            <span className="pu-none">-</span>
          )}
        </td>
        <td data-label="Deposits" className="text-nowrap">
          <div className="pu-amount">
            {toFixed(item.total_deposits, 2) || "0.00"}
          </div>
          <div className={`pu-orders ${item.order_deposits ? "has" : ""}`}>
            {item.order_deposits || 0} orders
          </div>
        </td>
        <td data-label="Withdrawals" className="text-nowrap">
          <div className="pu-amount">
            {toFixed(item.total_withdrawals, 2) || "0.00"}
          </div>
          <div className={`pu-orders ${item.order_withdrawals ? "has" : ""}`}>
            {item.order_withdrawals || 0} orders
          </div>
        </td>
        <td data-label="KYC" className="text-nowrap text-center">
          <div className="d-flex align-items-center justify-content-center">{this.renderKyc(item)}</div>
        </td>
        <td data-label="Status" className="text-nowrap text-center">
          <span className={`pr-status ${item.is_active ? "on" : "off"}`}>
            {item.is_active ? "Active" : "Inactive"}
          </span>
        </td>
        <td data-label="Mismatch" className="text-nowrap text-center">
          <div className="d-flex align-items-center justify-content-center">
            {item.qty_mismatch === 0 ? (
              <span className="pu-none">-</span>
            ) : item.qty_mismatch === 1 ? (
              Status(item.qty_mismatch, "warning")
            ) : (
              Status(item.qty_mismatch, "purple")
            )}
          </div>
        </td>
        <td data-label="CFR" className="text-nowrap text-center">
          {this.renderRisk(item, index)}
        </td>
        <td data-label="Actions" className="text-center customers.update td-actions">
          <Dropdown align="end">
            <Dropdown.Toggle className="pu-action-toggle" id={`customer-actions-${index}`}>
              Action
            </Dropdown.Toggle>
            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
            <Dropdown.Item
              className="pu-action-item customers.update"
              onClick={() => this.openUpdate(item)}
            >
              <span className="icon">{"\uf044"}</span>Update
            </Dropdown.Item>
            {!item.is_active &&
              ["admin", "super_user"].includes(profile?.user_type) && (
                <>
                  <div className="pu-action-sep" />
                  <Dropdown.Item
                    className="pu-action-item danger customers.delete"
                    onClick={() => this.Delete(item.uid)}
                  >
                    <span className="icon">{"\uf1f8"}</span>Delete
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  };
  renderToggle = ({ icon, title, desc, checked, onChange }) => (
    <label className={`pu-toggle ${checked ? "on" : ""}`}>
      <span className="pu-toggle-icon icon">{icon}</span>
      <span className="flex-grow-1 min-w-0">
        <span className="pu-toggle-title">{title}</span>
        <span className="pu-toggle-desc">{desc}</span>
      </span>
      <Switch {...SWITCH_PROPS} onChange={onChange} checked={checked} />
    </label>
  );

  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      filter_currency,
      filter_broker_id,
      filter_is_blacklist,
      filter_kyc_status,

      loaded,
      data,
      count,
      page,
      page_size,
      data_broker,
      data_bank,
      broker_id,
      currency,
      name_th,
      customer_ref,
      name_en,
      email,
      bank_code,
      bank_account_name_th,
      bank_account_name_en,
      bank_account_number,
      is_active,
      is_blacklist,
      destination_address,
      kyc_status,
    } = this.state;
    const rows = Array.isArray(data) ? data : [];
    const mismatchOnPage = rows.filter((e) => e.qty_mismatch !== 0).length;
    const bankOptions = data_bank.filter((e) =>
      e.country?.includes(
        global.currency?.find((c) => c.currency_code === currency)?.country ||
          "THAI"
      )
    );
    // ลูกค้าเดิมอาจผูกธนาคารที่ไม่อยู่ในลิสต์ของ gateway/สกุลเงินปัจจุบัน
    // ใส่ตัวที่เลือกอยู่เข้าไปด้วย ไม่งั้น Select โชว์ค่าว่างทั้งที่มี bank_code
    if (bank_code && !bankOptions.some((e) => e.value === bank_code)) {
      const known = global.bank.find((b) => b.value === bank_code);
      bankOptions.unshift({
        value: bank_code,
        label: known?.label || bank_code,
        front: (
          <img
            alt="bank"
            src={require(`../../assets/images/bank/${known?.icon || "bank.png"}`)}
            width={18}
            height={18}
            style={{ marginRight: 6 }}
          />
        ),
      });
    }
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Management</div>
                <div className="ar-title">Customers Management</div>
                <div className="ar-subtitle">
                  Manage customer profiles, bank accounts and risk status for
                  every broker.
                </div>
              </div>
              <div className="ar-hero-actions">
                <button
                  className="ar-btn-gold customers.create"
                  onClick={this.openCreate}
                >
                  <span className="icon me-2">{""}</span>Create Customer
                </button>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{""}</span>Filter</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field ar-filter-field-search">
<span className="ar-filter-label">Search</span>
<input
                type="text"
                className="form-control wpx-220"
                placeholder="Search name, UID, account..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Broker</span>
<Select
                  className="form-control"
                  placeholder="All brokers"
                  options={data_broker}
                  onChange={(e, i) => {
                    this.setState({ filter_broker_id: e });
                  }}
                  value={filter_broker_id}
                />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Blacklist</span>
<Select
                  className="form-control"
                  placeholder="Blacklist"
                  options={[
                    { value: "", label: "All (blacklist)" },
                    { value: true, label: "Blacklist" },
                    { value: false, label: "No Blacklist" },
                  ]}
                  value={filter_is_blacklist}
                  onChange={(v) => {
                    this.setState({ filter_is_blacklist: v });
                  }}
                  default={false}
                />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">KYC</span>
<Select
                  className="form-control"
                  placeholder="KYC"
                  options={KYC_FILTER_OPTIONS}
                  value={filter_kyc_status}
                  onChange={(v) => {
                    this.setState({ filter_kyc_status: v });
                  }}
                  default={false}
                />
</div>
<div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() =>
                  this.setState(
                    {
                      filter_search: "",
                      filter_currency: "THB",
                      filter_broker_id: "",
                      filter_is_blacklist: "",
      filter_kyc_status: "",
                    },
                    () => this.Get(1)
                  )
                }
              >
                Reset
              </button>
              </div>
</div>
<div className="ar-filter-foot">
<div className="d-flex align-items-center gap-2 flex-wrap">
                {global.currency?.map((item) => (
                  <button
                    key={item.currency_code}
                    className={`ar-pill ${
                      item.currency_code === filter_currency ? "active" : ""
                    }`}
                    onClick={() => {
                      this.setState({ filter_currency: item.currency_code }, () =>
                        this.Get(1)
                      );
                    }}
                  >
                    {item.image}
                    {item.currency_code}
                  </button>
                ))}
              </div>
</div>
</div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Customers
                  <span className="pu-currency-tag">{filter_currency}</span>
                </div>
                <div className="ar-table-caption">
                  {count || 0} customer{count === 1 ? "" : "s"} · showing{" "}
                  {rows.length} on this page
                  {mismatchOnPage > 0 && ` · ${mismatchOnPage} with mismatch`}
                </div>
              </div>
              <div className="ar-legend d-none d-md-flex align-items-center gap-3">
                <span>
                  <span className="pu-legend-dot on" />
                  Active
                </span>
                <span>
                  <span className="pu-legend-dot off" />
                  Inactive
                </span>
                <span>
                  <span className="pu-legend-swatch" />
                  Mismatch transactions
                </span>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table pu-table-compact">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-160">UID</td>
                    <td className="text-nowrap">Customer</td>
                    <td className="text-nowrap">Bank</td>
                    <td className="text-nowrap">Deposits</td>
                    <td className="text-nowrap">Withdrawals</td>
                    <td className="text-center text-nowrap wpx-100">KYC</td>
                    <td className="text-center text-nowrap wpx-100">Status</td>
                    <td className="text-center text-nowrap wpx-100">Mismatch</td>
                    <td className="text-center text-nowrap wpx-110">CFR</td>
                    <td className="text-center text-nowrap customers.update td-actions">
                      Actions
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={10} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No customers found</div>
                          <div className="text-secondary text-14">
                            Try another search, currency or broker.
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                  {rows.map(this.renderRow)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-between flex-wrap gap-2 mt-3">
            <div className="pu-remark">
              <span className="pu-legend-swatch" />
              Highlighted rows are customers with mismatch transactions
            </div>
            <Pagination
              className="mb-3"
              count={Math.ceil(count / page_size) || 1}
              page={page}
              showFirstButton
              showLastButton
              onChange={(_, value) => this.Get(value)}
            />
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          size="lg"
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={this.closeModal}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">
                {modal_create ? "New customer" : "Edit customer"}
              </div>
              <h5 className="fw-bold mb-0">
                {modal_create ? "Create" : modal_update ? "Update" : ""} Customer
              </h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            {/* BROKER */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Broker
              </div>
              <label className="pr-label">Broker{required}</label>
              <Select
                className="form-control pr-input"
                placeholder="Select broker"
                options={data_broker}
                onChange={(e, i) => {
                  this.setState({ broker_id: e });
                  if (e) {
                    // gateway is configured per currency; use the selected
                    // currency's gateway, falling back to the broker-level one.
                    const cur = this.state.currency;
                    const gw =
                      i.gateway_active?.find((g) => g.currency === cur)
                        ?.gateway_deposits || i.gateway;
                    if (!gw) {
                      alert(
                        "",
                        "warning",
                        "Warning",
                        "This broker has not configured a gateway. Unable to create customer."
                      );

                      this.setState({
                        broker_id: "",
                        bank_code: "",
                        bank_account_number: "",
                        bank_account_name_th: "",
                        bank_account_name_en: "",
                      });
                      return;
                    }
                    this.GetBank(gw);
                  }
                }}
                value={broker_id}
                disabled={profile?.user_type === "broker" || modal_update}
              />
              {modal_update && (
                <div className="pu-hint">
                  Broker cannot be changed after the customer is created.
                </div>
              )}
            </div>

            {/* BASIC INFORMATION */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Basic Information
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Currency</label>
                  <Select
                    className="form-control"
                    placeholder="Currency"
                    options={global.currency?.map((e) => ({
                      label: e.currency_name,
                      value: e.currency_code,
                      front: e.image,
                    }))}
                    onChange={(e, i) => {
                      this.setState({
                        currency: e,
                        bank_code: "",
                        bank_account_number: "",
                        bank_account_name_th: "",
                        bank_account_name_en: "",
                      });
                      // re-resolve the selected broker's gateway for this currency
                      const brk = this.state.data_broker?.find(
                        (b) => b.value === this.state.broker_id
                      );
                      if (brk && e) {
                        const gw =
                          brk.gateway_active?.find((g) => g.currency === e)
                            ?.gateway_deposits || brk.gateway;
                        if (gw) this.GetBank(gw);
                      }
                    }}
                    value={currency}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Ref</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Customer reference"
                    onChange={(e) => {
                      this.setState({ customer_ref: e.target.value });
                    }}
                    value={customer_ref}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Name TH{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="ชื่อภาษาไทย"
                    onChange={(e) => {
                      this.setState({ name_th: e.target.value });
                    }}
                    value={name_th}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Name EN{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="English name"
                    onChange={(e) => {
                      this.setState({ name_en: e.target.value });
                    }}
                    value={name_en}
                  />
                </div>
                <div className="col-12">
                  <label className="pr-label">Email</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="name@company.com"
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                    value={email}
                  />
                </div>
              </div>
            </div>

            {/* BANK INFORMATION */}
            <div className={`pu-section ${!broker_id ? "pu-section-muted" : ""}`}>
              <div className="pu-section-title">
                <span className="icon">{""}</span>Bank Information
                {!broker_id && (
                  <span className="pu-section-note">Select a broker first</span>
                )}
              </div>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="pr-label">Bank Name{required}</label>
                  <Select
                    className="form-control"
                    placeholder="Select bank"
                    options={bankOptions}
                    onChange={(e) => {
                      this.setState({ bank_code: e });
                    }}
                    value={bank_code}
                    disabled={!broker_id}
                  ></Select>
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Account Number{required}</label>
                  <div className="pu-password">
                    <input
                      type="text"
                      className="form-control pr-input"
                      placeholder="Account number"
                      maxLength={20}
                      onChange={(e) => {
                        if (!float(e.target.value)) return;
                        this.setState({ bank_account_number: e.target.value });
                      }}
                      value={bank_account_number}
                      disabled={!broker_id}
                    />
                    {currency === "LAK" && (
                      <button
                        type="button"
                        className="pu-generate"
                        title="Verify this bank account"
                        onClick={() => {
                          if (!bank_code) {
                            alert("", "warning", "Warning", "Please select Bank");
                            return;
                          } else if (!bank_account_number) {
                            alert(
                              "",
                              "warning",
                              "Warning",
                              "Please input Account Number"
                            );
                            return;
                          }
                          this.CheckAccount();
                        }}
                      >
                        <span className="icon me-2">{""}</span>Verify
                      </button>
                    )}
                  </div>
                  {currency === "LAK" && (
                    <div className="pu-hint">
                      To verify your bank account, please fill in your{" "}
                      <b>Bank Name</b> and <b>Account Number</b>.
                    </div>
                  )}
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Account Name TH{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="ชื่อบัญชีภาษาไทย"
                    onChange={(e) => {
                      this.setState({ bank_account_name_th: e.target.value });
                    }}
                    value={bank_account_name_th}
                    disabled={!broker_id}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="pr-label">Account Name EN{required}</label>
                  <input
                    type="text"
                    className="form-control pr-input"
                    placeholder="Account name in English"
                    onChange={(e) => {
                      this.setState({ bank_account_name_en: e.target.value });
                    }}
                    value={bank_account_name_en}
                    disabled={!broker_id}
                  />
                </div>
              </div>
            </div>

            {/* PRIMERLO (THAI QR) */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{"\uf3d1"}</span>Primerlo (Thai QR)
                {modal_update && (
                  <span className="pu-section-note d-flex align-items-center">
                    KYC
                    {kyc_status ? (
                      <span className="ms-2">{Status(kyc_status, KYC_COLORS[kyc_status] || "secondary")}</span>
                    ) : (
                      <span className="pu-none ms-2">-</span>
                    )}
                  </span>
                )}
              </div>
              <div className="row g-3">
                <div className="col-12">
                  <label className="pr-label">Destination Address (BSC)</label>
                  <input
                    type="text"
                    className="form-control pr-input pu-mono"
                    placeholder="0x…"
                    maxLength={42}
                    onChange={(e) => {
                      this.setState({ destination_address: e.target.value.trim() });
                    }}
                    value={destination_address || ""}
                  />
                  <div className="pu-hint">
                    USDT (BEP20) address on BSC that receives this customer's buys. Leave empty to let the system use the
                    newest address known to Primerlo, or the company address, on the first deposit.
                  </div>
                </div>
                {/* ลิงก์หน้า KYC: เฉพาะตอนแก้ไขและ broker ของลูกค้าใช้ primerlo (ลิงก์ออกจาก Backend อายุ 24 ชม.) */}
                {modal_update && this.state.broker?.uses_primerlo && (
                  <div className="col-12">
                    <label className="pr-label">KYC Link</label>
                    <div className="d-flex flex-wrap gap-2">
                      <button type="button" className="btn btn-sm btn-outline-warning" onClick={() => this.OpenKyc({ uid: this.state.uid })}>
                        <span className="icon me-1">{"\uf2c2"}</span>Open KYC page
                      </button>
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.OpenKyc({ uid: this.state.uid }, true)}>
                        <span className="icon me-1">{"\uf0c5"}</span>Copy KYC link
                      </button>
                    </div>
                    <div className="pu-hint">Send this link to the customer to verify identity and add a bank account. The link expires in 24 hours.</div>
                  </div>
                )}
              </div>
            </div>

            {/* STATUS */}
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Risk &amp; status
              </div>
              <div className="row g-2">
                <div className="col-12 col-md-6">
                  {this.renderToggle({
                    icon: "",
                    title: "Blacklist",
                    desc: "Flag this customer for additional review",
                    checked: !!is_blacklist,
                    onChange: (e) => this.setState({ is_blacklist: e }),
                  })}
                </div>
                <div className="col-12 col-md-6">
                  {this.renderToggle({
                    icon: "",
                    title: "Active",
                    desc: "Allow transactions for this customer",
                    checked: !!is_active,
                    onChange: (e) => this.setState({ is_active: e }),
                  })}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={this.closeModal}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
